<template>
	<div>
		<v-row>
			<v-col :cols="selectAllOption ? 10 : 12">
				<autocomplete-basic-with-emits
					:label="label"
					:keyIndex="keyIndex"
					:show="showLocal"
					:items="items"
					:itemText="itemText"
					:compositeItemText="compositeItemText"
					:model="selectedItems"
					:search="search"
					:disabled="disabledLocal"
					:selectAllChecked="checkboxSelectAll"
					:wildcardUsage="true"
					:hint="hint"
					:clearable="clearable"
					:groupingEffect="groupingEffect"
					@modelEmit="updateModel"
					@searchEmit="updateSearch"
				/>
			</v-col>
			<div v-show="showLocal">
				<v-col cols="2" v-if="selectAllOption" class="checkboxDiv">
					<v-checkbox
						class="checkboxSelectAll"
						v-model="checkboxSelectAll"
						:label="txt.all"
					></v-checkbox>
				</v-col>
			</div>
		</v-row>
	</div>
</template>

<script>
import axios from 'axios'
import AutocompleteBasicWithEmits from '../../vueBasics/AutocompleteBasicWithEmits.vue'

export default {
	name: 'GenericAutocomplete',
	components: {
		AutocompleteBasicWithEmits,
	},
	props: {
		api: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		preSelectAndHideIfOneItem: {
			type: Boolean,
			default: true,
		},
		show: {
			type: Boolean,
			default: true,
		},
		selectAllOption: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		queryProps: {
			type: Array,
			required: false,
		},
		queryPropValues: {
			type: Array,
			required: false,
		},
		triggerValue: {
			type: Number,
			required: true,
		},
		groupingEffect: {
			type: Boolean,
			default: false,
		},
		itemText: {
			required: false,
		},
		compositeItemText: {
			type: Array,
			required: false,
		},
	},
	data() {
		return {
			items: ['could not be loaded due unknown mandator'],
			selectedItems: [],
			loadingData: false,
			search: null,
			showLocal: this.show,
			checkboxSelectAll: false,
			txt: {
				all: 'all',
			},
			keyIndex: 0,
			disabledLocal: this.disabled,
			clearable: false,
			hint: 'this is a test hint',
		}
	},
	watch: {
		loadingData: {
			handler(loadingData) {
				this.$emit('loading', loadingData)
			},
		},
		selectedItems: {
			handler(itemsSelected) {
				this.setClearableIfMoreThanThreeItemsSelected(itemsSelected)
				this.$emit('modelEmit', itemsSelected)
			},
		},
		checkboxSelectAll: {
			handler() {
				this.checkboxHandlerSelectAll(this.checkboxSelectAll)
			},
		},
		triggerValue: {
			handler(triggerValue) {
				if (triggerValue !== 9999) {
					const apiRouteAssembled = this.propBuilder(this.queryProps, this.queryPropValues)
					this.getItems(apiRouteAssembled)
					// force clear selected items in child
					this.selectedItems = []
					this.checkboxSelectAll = false
					this.keyIndex += 1
				}
			},
			immediate: true,
		},
		show: {
			handler(value) { this.showLocal = value },
		},
		disabled: {
			handler(value) { this.disabledLocal = value },
		},
	},
	methods: {
		async getItems(apiToCall) {
			try {
				this.selectedItems = []
				this.loadingData = true
				// eslint-disable-next-line no-undef
				const apiRoute = `${config.baseAPIurl}${apiToCall}`
				const response = await axios.get(apiRoute)
				this.items = response.data
				this.handleItemsListAfterFetching()
				this.loadingData = false
			} catch (error) {
				this.$emit('errorEmit', error)
			}
		},
		propBuilder(props, values) {
			if (!props) return this.api
			if (props.length !== values.length) throw new Error('uneven prop and prop value length')
			// eslint-disable-next-line prefer-const
			let queryPropsAssembled = []
			for (let i = 0; i < props.length; i += 1) {
				queryPropsAssembled.push(`${props[i].name}=${values[i]}`)
			}
			return `${this.api}?${queryPropsAssembled.join('&')}`
		},
		updateModel(value) {
			this.selectedItems = value
		},
		updateSearch(value) {
			this.search = value
		},
		filterAutoFillAndHide() {
			if (this.items.length === 1) {
				this.selectedItems = this.items
				this.showLocal = false
			}
		},
		handleItemsListAfterFetching() {
			// hide if only one is loaded
			if (this.preSelectAndHideIfOneItem) this.filterAutoFillAndHide()
			// if empty, add message
			if (this.items.length === 0) this.items.push('could not find any item')
		},
		checkboxHandlerSelectAll(selected) {
			this.selectedItems = []
			this.disabledLocal = selected
			this.keyIndex += 1
			if (selected) this.selectedItems = this.items
		},
		setClearableIfMoreThanThreeItemsSelected(items) {
			if (items.length > 3) {
				this.clearable = true
				return
			}
			this.clearable = false
		},
	},
}
</script>

<style scoped>
.checkboxSelectAll {
	margin-top: 30px;
	padding-top: 0em;
	padding-left: 4px;
}
.checkboxDiv {
	padding-left: 0px;
}
.divIncludingToolTip {
	padding: 0%;
	margin: 0%;
}
</style>
